"use client";

import OwnerCard from "@/components/OwnerCard";
import br from "@/styles/breakpoints.module.css";
import { UserDetails } from "@knowt/syncing/graphql/schema";

const SetOverviewOwnerCard = ({
    ownerData,
    userId,
}: {
    ownerData: UserDetails;
    userId?: string;
}) => {
    return (
        <OwnerCard
            className={br.smDownWidth100}
            isSelf={ownerData?.ID === userId}
            owner={ownerData}
            variant={"horizontal"}
            style={{
                padding: "1.5rem",
            }}
        />
    );
};

export default SetOverviewOwnerCard;
